import { injectScript } from '@atc/dom-fns';
const injectSDPScript = async () => {
  try {
    injectScript('https://shop.dealer.com/widget.sdp.js');
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Error injecting accelerate digital retail script: ', err);
    if (window && window.newrelic) {
      window.newrelic.addPageAction('ThirdPartyError', {
        thirdPartyName: 'Accelerate',
        component: 'DigitalOverlayHelpers',
        message: 'Error injecting accelerate digital retail script',
        status: err?.status || 'unknown',
        url: window.location.href,
        error: err
      });
    }
  }
};
const waitForAccelerate = async () => new Promise(resolve => {
  const checkAccelerate = () => {
    if (window.accelerate) {
      resolve();
    } else {
      requestAnimationFrame(checkAccelerate);
    }
  };
  checkAccelerate();
});
const digitalOverlayHelpers = {
  injectSDPScript,
  waitForAccelerate
};
export { digitalOverlayHelpers as default };
